<template>
  <div class="bank-information-page">
    <v-container class="main-container responsive-height">
      <v-row dense>
        <v-col cols="12" class="position-relative">
          <BankInfoAllTabs></BankInfoAllTabs>
          <div class="bank-dropdown">
            <DropdownMenu></DropdownMenu>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BankInfoAllTabs from "@/components/PagesComponents/BankInformation/BankInfoAllTabs";
import DropdownMenu from "@/components/PagesComponents/BankInformation/DropdownMenu";
export default {
  components: {
    BankInfoAllTabs,
    DropdownMenu,
  },
};
</script>
